'use es6';

import { Route, Redirect, Switch } from 'react-router-dom';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { SUMMARY, PREVIEW } from './lib/RouteNames';
import ViewContainerDecorator from 'documents-lib/js/decorators/ViewContainerDecorator';
import PublicViewLoading from 'documents-lib/js/components/view/PublicViewLoading';
import ViewError from 'documents-lib/js/components/view/ViewError';
import * as DocumentsActions from './actions/DocumentsActions';
import { hasHigherDocumentsLimit } from './lib/permissions';
import Application from './containers/Application';
import IndexContainer from './containers/IndexContainer';
import SummaryContainer from './containers/SummaryContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const View = Loadable({
  loader: () => import( /* webpackChunkName: "document-preview-bundle" */
  'documents-lib/js/containers/ViewContainer').then(component => ViewContainerDecorator(component.default, {
    documentActions: DocumentsActions,
    isPreview: true,
    hasHigherDocumentsLimit
  })),
  LoadingComponent: PublicViewLoading,
  ErrorComponent: ViewError
});
export default /*#__PURE__*/_jsx(Route, {
  path: "/",
  render: props => /*#__PURE__*/_jsx(Application, Object.assign({}, props, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: `/${SUMMARY}/:deckId`,
        component: SummaryContainer
      }), /*#__PURE__*/_jsx(Route, {
        path: `/${PREVIEW}/:presentationId`,
        component: View
      }), /*#__PURE__*/_jsx(Redirect, {
        from: "/reports/deck/:deckId",
        to: `/${SUMMARY}/:deckId`
      }), /*#__PURE__*/_jsx(Route, {
        index: true,
        component: IndexContainer
      })]
    })
  }))
});